/* LA DIVINE — configurateur saveurs (voie 2 : configurateur natif + produit supplément).
   Préremplissage (spec finale Simon) : dispatch à parts égales entre les 6 saveurs
   PERMANENTES ; éphémère toujours 0. base=floor(N/6), reste +1 dans l'ordre de priorité
   (= ordre DOM des permanentes) ; Grande Divine (PM) défaut = Rhum Ambré.
   Input central éditable (inputmode numeric), clamp [0..], somme=N imposée live, reset.
   window.LD_CONFIG_SIMULATE=true → n'appelle pas /cart/add.js (log l'payload) : pour tests. */
(function () {
  /* Prefixe de locale (27/08) : un appel Ajax panier a la racine part en redirection vers
     /fr-fr/... a chaque synchro. Shopify.routes.root vaut '/fr-fr/' sur une page FR. */
  function ldRacine() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  function nums(el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }
  function val(counter) { var i = counter.querySelector('[data-ld-val]'); return parseInt(i.value != null ? i.value : i.textContent, 10) || 0; }
  function setVal(counter, n) { var i = counter.querySelector('[data-ld-val]'); if (i.value != null) i.value = n; else i.textContent = n; counter.querySelector('[data-ld-input]').value = n; }

  function prefill(cfg) {
    var total = parseInt(cfg.dataset.total, 10) || 6;
    var perms = nums(cfg, '[data-ld-counter]').filter(function (c) { return !c.dataset.ephem; });
    var base = Math.floor(total / 6), rem = total % 6;
    perms.forEach(function (c, i) { setVal(c, base + (i < rem ? 1 : 0)); });
    nums(cfg, '[data-ld-counter]').filter(function (c) { return c.dataset.ephem; }).forEach(function (c) { setVal(c, 0); });
    // Grande Divine (PM) : radio défaut Rhum Ambré
    var grande = cfg.querySelector('[data-ld-grande]');
    if (grande) { var r = grande.querySelector('input[value="Rhum Ambré"]') || grande.querySelector('input'); if (r) r.checked = true; }
  }

  function clearAll(cfg) { nums(cfg, '[data-ld-counter]').forEach(function (c) { setVal(c, 0); }); }

  // Feedback assortiment incomplet (clic « Ajouter » avec compteur ≠ N) : message sous le bouton + highlight ~1s du compteur.
  function incompleteText(cfg, s, total) {
    var tInc = cfg.dataset.i18nIncomplete || 'Complétez votre assortiment avant d’ajouter au panier ({x}/{n} saveurs choisies).';
    return tInc.replace('{x}', s).replace('{n}', total);
  }
  function showIncomplete(cfg, s, total) {
    var el = cfg.querySelector('[data-ld-incomplete]');
    var msg = cfg.querySelector('[data-ld-incomplete-msg]');
    if (msg) msg.textContent = incompleteText(cfg, s, total);
    if (el) el.style.display = 'flex';
    var cnt = cfg.querySelector('[data-ld-count]'), cw = cnt ? cnt.parentNode : null;
    if (cw) { cw.classList.remove('ldc-nudge', 'ldc-pulse'); void cw.offsetWidth; cw.classList.add('ldc-nudge'); } // relance l'animation
  }

  // OB4 — assortiment conseillé (identique à prefill) SANS muter le DOM : sert à savoir si la compo
  // courante == la sélection maison (→ bouton « Notre sélection » actif). Grande Divine incluse (PM).
  function recommended(cfg) {
    var total = parseInt(cfg.dataset.total, 10) || 6;
    var perms = nums(cfg, '[data-ld-counter]').filter(function (c) { return !c.dataset.ephem; });
    var base = Math.floor(total / 6), rem = total % 6, counts = {};
    perms.forEach(function (c, i) { counts[c.dataset.name] = base + (i < rem ? 1 : 0); });
    nums(cfg, '[data-ld-counter]').filter(function (c) { return c.dataset.ephem; }).forEach(function (c) { counts[c.dataset.name] = 0; });
    var grande = cfg.querySelector('[data-ld-grande]'), gval = null;
    if (grande) { var r = grande.querySelector('input[value="Rhum Ambré"]') || grande.querySelector('input'); if (r) gval = r.value; }
    return { counts: counts, grande: gval };
  }
  function composition(cfg) {
    var counts = {};
    nums(cfg, '[data-ld-counter]').forEach(function (c) { counts[c.dataset.name] = val(c); });
    var g = cfg.querySelector('[data-ld-grande] input:checked');
    return { counts: counts, grande: g ? g.value : null };
  }
  function sameComp(a, b) {
    var keys = {}; Object.keys(a.counts).forEach(function (k) { keys[k] = 1; }); Object.keys(b.counts).forEach(function (k) { keys[k] = 1; });
    for (var k in keys) { if ((a.counts[k] || 0) !== (b.counts[k] || 0)) return false; }
    return (a.grande || null) === (b.grande || null);
  }
  function isEmpty(cfg) { return nums(cfg, '[data-ld-counter]').every(function (c) { return val(c) === 0; }); }
  // B10-3 — la Grande Divine sommitale sélectionnée est-elle une saveur ÉPHÉMÈRE ? (→ supplément +0,30 €)
  var GRANDE_SUPP = 0.30; // Pack (brief, tableau prix) : Grande Divine sommitale en éphémère = +0,30 €
  function grandeEphActive(cfg) {
    var g = cfg.querySelector('[data-ld-grande] input:checked');
    if (!g) return false;
    return nums(cfg, '[data-ld-counter]').some(function (c) { return c.dataset.ephem && c.dataset.name === g.value; });
  }
  // OB4 — pose/retire .is-active (dérive de la COMPO, pas du clic) + aria-pressed synchronisé.
  function refreshActive(cfg) {
    var pf = cfg.querySelector('[data-ld-prefill]');
    if (pf) { var on = sameComp(composition(cfg), recommended(cfg)); pf.classList.toggle('is-active', on); pf.setAttribute('aria-pressed', on ? 'true' : 'false'); }
    var cl = cfg.querySelector('[data-ld-clear]');
    if (cl) { var z = isEmpty(cfg); cl.classList.toggle('is-active', z); cl.setAttribute('aria-pressed', z ? 'true' : 'false'); }
  }

  // H2 — coffrets : carte {nb éphémères → {id, price(cents)}} exposée par le bloc (data-ld-variants).
  function variantMap(cfg) { try { return JSON.parse(cfg.dataset.ldVariants || '{}'); } catch (e) { return {}; } }

  function refresh(cfg) {
    var total = parseInt(cfg.dataset.total, 10) || 6;
    var s = 0, ephem = 0;
    nums(cfg, '[data-ld-counter]').forEach(function (c) { var v = val(c); s += v; if (c.dataset.ephem) ephem += v; c.classList.toggle('has-count', v > 0); c.querySelector('[data-ld-input]').value = v; var plus = c.querySelector('[data-ld-plus]'); if (plus) plus.disabled = (s >= total && v === val(c)); var minus = c.querySelector('[data-ld-minus]'); if (minus) minus.disabled = (v <= 0); });
    // recalcul plafond des "+"
    nums(cfg, '[data-ld-counter]').forEach(function (c) { var plus = c.querySelector('[data-ld-plus]'); if (plus) plus.disabled = (s >= total); });
    var ok = (s === total);
    // Feedback pré-panier : PLUS de disabled persistant sur le CTA (le clic déclenche le message si incomplet).
    // Le message « Complétez… » disparaît dès que ok ; s'il est déjà affiché et encore incomplet, on met à jour {x}/{n}.
    cfg.classList.toggle('is-complete', ok);
    var incEl = cfg.querySelector('[data-ld-incomplete]');
    if (incEl) {
      if (ok) { incEl.style.display = 'none'; }
      else if (incEl.style.display !== 'none') {
        var msg = cfg.querySelector('[data-ld-incomplete-msg]');
        if (msg) msg.textContent = incompleteText(cfg, s, total);
      }
    }
    // i18n : templates via data-attributes (fallback FR) ; {n}=total {x}=reste {k}=éphém {m}=montant
    var d = cfg.dataset;
    var tOk = d.i18nOk || 'Parfait, {n} saveurs sélectionnées.';
    var tMore = d.i18nMore || 'Encore {x} à choisir (répétitions autorisées).';
    var tOver = d.i18nOver || 'Retirez {x} saveur(s).';
    var tSupp = d.i18nSupp || 'Dont {k} éphémère(s) : +{m} €';
    var hint = cfg.querySelector('[data-ld-hint]');
    if (hint) hint.textContent = ok ? tOk.replace('{n}', total) : (s < total ? tMore.replace('{x}', total - s) : tOver.replace('{x}', s - total));
    var cnt = cfg.querySelector('[data-ld-count]');
    if (cnt) { cnt.textContent = s; var cw = cnt.parentNode; if (cw) { cw.classList.remove('ldc-pulse'); void cw.offsetWidth; cw.classList.add('ldc-pulse'); } }
    var supEl = cfg.querySelector('[data-ld-supp]');
    var unit = parseFloat(cfg.dataset.suppUnit || '0.30');
    var grandeEph = grandeEphActive(cfg);
    if (supEl) {
      var parts = [];
      if (ephem > 0) parts.push(tSupp.replace('{k}', ephem).replace('{m}', (ephem * unit).toFixed(2).replace('.', ',')));
      if (grandeEph) {
        var isEnG = (document.documentElement.lang || '').slice(0, 2).toLowerCase() === 'en';
        parts.push((isEnG ? 'Incl. top supplement: +' : 'Dont supplément sommitale : +') + GRANDE_SUPP.toFixed(2).replace('.', ',') + ' €');
      }
      supEl.textContent = parts.join(' · ');
    }
    // prix total dynamique. Coffrets (H2) : prix de la VARIANTE (= nb éphémères) × qté. PM : base + supplément × qté (+ sommitale éphémère).
    var totalEl = cfg.querySelector('[data-ld-total]');
    if (totalEl) {
      var qn = getQty(cfg), tot;
      if (cfg.dataset.mode === 'coffret') {
        var vm = variantMap(cfg), e = vm[ephem];
        tot = (e ? e.price / 100 : parseFloat(cfg.dataset.basePrice || '0')) * qn;
      } else {
        tot = (parseFloat(cfg.dataset.basePrice || '0') + ephem * unit + (grandeEph ? GRANDE_SUPP : 0)) * qn;
      }
      totalEl.textContent = tot.toFixed(2).replace('.', ',') + ' €';
    }
    refreshActive(cfg);
    return { sum: s, ephem: ephem, ok: ok };
  }

  function clampInput(cfg, counter) {
    var total = parseInt(cfg.dataset.total, 10) || 6;
    var others = 0;
    nums(cfg, '[data-ld-counter]').forEach(function (c) { if (c !== counter) others += val(c); });
    var v = val(counter);
    if (v < 0 || isNaN(v)) v = 0;
    if (others + v > total) v = Math.max(0, total - others);
    setVal(counter, v);
  }

  function getQty(cfg) { var q = cfg.querySelector('[data-ld-qty]'); var n = q ? (parseInt(q.value, 10) || 1) : 1; return n < 1 ? 1 : n; }

  // C2 — met à jour la pastille compteur du header sans recharger la page (lit /cart.js).
  // N'ouvre PAS le drawer : celui-ci n'écoute que l'évènement cart:add, pas cart:update.
  function updateCartBubble() {
    fetch(ldRacine() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart) return;
        // B10-4 — le badge (et le titre « Panier ») comptent les ARTICLES hors lignes Supplément
        // (produit caché lié : propriété `_lié` ou `Supplément`), sinon 1 coffret + son supplément = 2.
        var count = 0;
        (cart.items || []).forEach(function (it) { var p = it.properties || {}; if (p['_lié'] != null || p['Supplément'] != null) return; count += (it.quantity || 0); });
        document.querySelectorAll('.cart-bubble__text-count, [ref="cartBubbleCount"]').forEach(function (el) { el.textContent = count; el.classList.toggle('hidden', count === 0); });
        document.querySelectorAll('.cart-bubble').forEach(function (el) { el.classList.toggle('visually-hidden', count === 0); });
        var ci = document.querySelector('cart-icon'); if (ci) ci.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
        try { sessionStorage.setItem('cart-count', JSON.stringify({ value: String(count), timestamp: Date.now() })); } catch (e) {}
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { itemCount: count, source: 'ladivine-configurator' } } }));
      })
      .catch(function () {});
  }

  // B10-2 — ouvre le drawer panier (méthode publique du composant Horizon).
  function openCartDrawer() {
    var d = document.querySelector('cart-drawer-component');
    if (d && typeof d.open === 'function') { try { d.open(); } catch (e) {} }
  }

  function addToCart(cfg) {
    var mainId = cfg.dataset.variantId;
    var qty = getQty(cfg);
    var props = {};
    nums(cfg, '[data-ld-counter]').forEach(function (c) { var v = val(c); if (v > 0) props[c.dataset.name] = v; });
    var grande = cfg.querySelector('[data-ld-grande] input:checked');
    if (grande) props['Grande Divine'] = grande.value;
    var ephem = 0; nums(cfg, '[data-ld-counter]').forEach(function (c) { if (c.dataset.ephem) ephem += val(c); });
    var items;
    if (cfg.dataset.mode === 'coffret') {
      // H2 — coffrets : UNE ligne = la variante correspondant au nb d'éphémères. PLUS de ligne Supplément, ni _éph, ni _lié.
      var vm = variantMap(cfg), e = vm[ephem];
      items = [{ id: (e ? e.id : mainId), quantity: qty, properties: props }];
    } else {
      // PM — ligne PM (+ _éph) + ligne Supplément éphémère (× qté) + éventuel supplément SOMMITALE (+0,30). Toutes réconciliées par E1.
      props['_éph'] = ephem;
      // B10-3 — grande sommitale éphémère : on marque la ligne PM (_grandeEph=1) ET on ajoute le supplément +0,30 (tag _liéG, distinct du _lié).
      var grandeEph = grandeEphActive(cfg);
      if (grandeEph) props['_grandeEph'] = 1;
      items = [{ id: mainId, quantity: qty, properties: props }];
      var supId = cfg.dataset.suppVariantId;
      if (supId && ephem > 0) items.push({ id: supId, quantity: ephem * qty, properties: { 'Supplément': 'saveurs éphémères', '_lié': mainId } });
      var grandeEl = cfg.querySelector('[data-ld-grande]');
      var grandeSuppId = grandeEl && grandeEl.dataset.suppVariantId;
      if (grandeEph && grandeSuppId) items.push({ id: grandeSuppId, quantity: qty, properties: { 'Supplément': 'sommitale éphémère', '_liéG': mainId } });
    }
    var payload = { items: items };
    if (window.LD_CONFIG_SIMULATE) { (window.LD_LAST_PAYLOAD = payload); if (window.LD_LOG) window.LD_LOG(payload); return Promise.resolve(payload); }
    var errEl = cfg.querySelector('[data-ld-error]');
    if (errEl) { errEl.textContent = ''; errEl.style.display = 'none'; }
    var addBtn = cfg.querySelector('[data-ld-add]'); if (addBtn) addBtn.disabled = true;
    return fetch(ldRacine() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error((res.body && (res.body.description || res.body.message)) || 'Ajout impossible'); }
        // C2 — on RESTE sur la fiche : aucune navigation, aucun reset de l'assortiment.
        // Feedback léger « Ajouté ✓ » (~2 s) puis retour au libellé, + pastille panier rafraîchie.
        var isEn = (document.documentElement.lang || '').slice(0, 2).toLowerCase() === 'en';
        if (addBtn) {
          if (!addBtn.dataset.ldLabel) addBtn.dataset.ldLabel = (addBtn.textContent || '').trim();
          addBtn.textContent = isEn ? 'Added ✓' : 'Ajouté ✓';
          addBtn.classList.add('is-added');
          if (addBtn._ldRevert) clearTimeout(addBtn._ldRevert);
          addBtn._ldRevert = setTimeout(function () { addBtn.textContent = addBtn.dataset.ldLabel; addBtn.classList.remove('is-added'); addBtn.disabled = false; refresh(cfg); }, 2000);
        }
        updateCartBubble();
        // B10-2 — le drawer ne s'ouvrait pas après l'ajout custom (on n'émet pas le CartAddEvent natif).
        // On appelle directement la méthode publique open() du cart-drawer (indépendante de l'attribut auto-open).
        // Petit délai : laisser le cart:update (updateCartBubble) rafraîchir le contenu du drawer avant l'ouverture.
        setTimeout(openCartDrawer, 250);
      })
      .catch(function (e) {
        if (addBtn) addBtn.disabled = false;
        var isEn = (document.documentElement.lang || '').slice(0, 2).toLowerCase() === 'en';
        var msg = (isEn ? 'Sorry, we could not add this box. Please try again or contact us.' : 'Désolé, l’ajout au panier a échoué. Réessayez ou contactez-nous : commande@ladivine-paris.com') + ' (' + e.message + ')';
        if (errEl) { errEl.textContent = msg; errEl.style.display = 'block'; }
        else { alert(msg); }
      });
  }

  function init(cfg) {
    if (cfg.dataset.ldReady) return; // garde anti double-init (évite double écouteur → +2)
    cfg.dataset.ldReady = '1';
    // F1/F2 — au chargement : coffrets partent À ZÉRO (pas de préremplissage) ; pièces montées (mode pm)
    // gardent la suggestion complète. Le bouton « Notre sélection » applique la suggestion à la demande dans les deux cas.
    if (cfg.dataset.mode === 'pm') prefill(cfg);
    refresh(cfg);
    cfg.addEventListener('click', function (e) {
      var c = e.target.closest('[data-ld-counter]');
      if (c) {
        if (e.target.matches('[data-ld-plus]')) { var s = 0; nums(cfg, '[data-ld-counter]').forEach(function (x) { s += val(x); }); if (s < (parseInt(cfg.dataset.total, 10) || 6)) setVal(c, val(c) + 1); }
        if (e.target.matches('[data-ld-minus]') && val(c) > 0) setVal(c, val(c) - 1);
        refresh(cfg);
      }
      if (e.target.matches('[data-ld-reset]') || e.target.matches('[data-ld-prefill]') || e.target.matches('[data-ld-useselection]')) { prefill(cfg); refresh(cfg); }
      if (e.target.matches('[data-ld-clear]')) { clearAll(cfg); refresh(cfg); }
      var q = cfg.querySelector('[data-ld-qty]');
      if (q && e.target.matches('[data-ld-qtyplus]')) { q.value = (parseInt(q.value, 10) || 1) + 1; refresh(cfg); }
      if (q && e.target.matches('[data-ld-qtyminus]')) { q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); refresh(cfg); }
    });
    // Ajout panier : binding DIRECT sur le bouton (robuste au refactor de layout) + erreur toujours visible
    var addBtn = cfg.querySelector('[data-ld-add]');
    if (addBtn) addBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (addBtn.disabled) return; // garde transitoire pendant l'ajout réseau (évite double-submit)
      var total = parseInt(cfg.dataset.total, 10) || 6, s = 0;
      nums(cfg, '[data-ld-counter]').forEach(function (x) { s += val(x); });
      if (s === total) { addToCart(cfg); }
      else { showIncomplete(cfg, s, total); } // assortiment incomplet → message sous le bouton + highlight compteur
    });
    // Module de comptage : version condensée quand il devient sticky (collé sous le header)
    var sentinel = cfg.querySelector('.ldc__sentinel');
    var mod = cfg.querySelector('[data-ld-module]');
    if (sentinel && mod && 'IntersectionObserver' in window) {
      var hh = 64; try { hh = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10) || 64; } catch (e) {}
      new IntersectionObserver(function (es) { mod.classList.toggle('is-stuck', es[0].intersectionRatio === 0); }, { rootMargin: '-' + (hh + 2) + 'px 0px 0px 0px', threshold: [0, 1] }).observe(sentinel);
    }
    cfg.addEventListener('input', function (e) {
      var c = e.target.closest('[data-ld-counter]');
      if (c && e.target.matches('[data-ld-val]')) { clampInput(cfg, c); refresh(cfg); }
      if (e.target.matches('[data-ld-qty]')) { refresh(cfg); }
    });
    cfg.addEventListener('change', function (e) { if (e.target.closest('[data-ld-grande]')) refresh(cfg); });
  }

  // Masque les buy-buttons Horizon natifs sur les produits configurés (le configurateur les remplace).
  function hideNativeBuy() {
    var sels = ['add-to-cart-component', 'quantity-selector-component', 'accelerated-checkout-component', '.shopify-payment-button', 'buy-buttons-block', 'sticky-add-to-cart', '.sticky-add-to-cart', 'variant-picker'];
    sels.forEach(function (s) { document.querySelectorAll(s).forEach(function (el) { if (!el.closest('[data-ld-config]')) el.style.display = 'none'; }); });
  }

  window.LDConfig = { init: init, prefill: prefill, refresh: refresh };
  function boot() { var cfgs = nums(document, '[data-ld-config]'); cfgs.forEach(init); if (cfgs.length) hideNativeBuy(); }
  document.addEventListener('DOMContentLoaded', boot);
  if (document.readyState !== 'loading') boot();
})();
